module.exports = __webpack_public_path__ + "static/media/sm-home-laptop.14d2507e.png";